import React, { useState, useMemo } from 'react';
import { Icon } from '@iconify/react';

// Curated Solar bold-duotone icons relevant to memorial park / real estate / CRM
const ICON_SET: { id: string; tags: string }[] = [
  // Nature & Landscape
  { id: 'solar:sun-bold-duotone', tags: 'sun light day lawn' },
  { id: 'solar:sun-2-bold-duotone', tags: 'sun bright' },
  { id: 'solar:moon-bold-duotone', tags: 'moon night' },
  { id: 'solar:cloud-bold-duotone', tags: 'cloud sky' },
  { id: 'solar:tree-bold-duotone', tags: 'tree garden nature estate' },
  { id: 'solar:leaf-bold-duotone', tags: 'leaf nature green garden scatter' },
  { id: 'solar:flower-bold-duotone', tags: 'flower garden memorial' },
  { id: 'solar:mountains-bold-duotone', tags: 'mountain hill landscape' },
  { id: 'solar:water-bold-duotone', tags: 'water fountain lake' },
  // Buildings & Structures
  { id: 'solar:home-2-bold-duotone', tags: 'home house chapel building' },
  { id: 'solar:home-bold-duotone', tags: 'home house crypt' },
  { id: 'solar:buildings-bold-duotone', tags: 'building mausoleum tower' },
  { id: 'solar:buildings-2-bold-duotone', tags: 'building city structure' },
  { id: 'solar:buildings-3-bold-duotone', tags: 'building complex' },
  { id: 'solar:garage-bold-duotone', tags: 'garage vault crypt' },
  { id: 'solar:shop-bold-duotone', tags: 'shop store structure' },
  // Storage & Archive
  { id: 'solar:archive-bold-duotone', tags: 'archive columbarium niche storage' },
  { id: 'solar:box-bold-duotone', tags: 'box ossuary container' },
  { id: 'solar:inbox-bold-duotone', tags: 'inbox container niche' },
  { id: 'solar:safe-2-bold-duotone', tags: 'safe vault crypt' },
  // Map & Location
  { id: 'solar:map-bold-duotone', tags: 'map location lot section' },
  { id: 'solar:map-point-bold-duotone', tags: 'map pin location marker' },
  { id: 'solar:map-arrow-square-bold-duotone', tags: 'map direction navigate' },
  { id: 'solar:compass-bold-duotone', tags: 'compass direction navigate' },
  { id: 'solar:globe-bold-duotone', tags: 'globe world earth' },
  // People & Users
  { id: 'solar:user-bold-duotone', tags: 'user person single' },
  { id: 'solar:users-group-rounded-bold-duotone', tags: 'users group family people' },
  { id: 'solar:user-plus-bold-duotone', tags: 'user add new person' },
  { id: 'solar:user-heart-bold-duotone', tags: 'user love memorial remember' },
  // Symbols & Objects
  { id: 'solar:star-bold-duotone', tags: 'star premium vip special' },
  { id: 'solar:medal-ribbons-star-bold-duotone', tags: 'medal award premium' },
  { id: 'solar:crown-bold-duotone', tags: 'crown premium royal vip' },
  { id: 'solar:diamond-bold-duotone', tags: 'diamond premium luxury' },
  { id: 'solar:heart-bold-duotone', tags: 'heart love memorial' },
  { id: 'solar:shield-bold-duotone', tags: 'shield protect guard' },
  { id: 'solar:key-bold-duotone', tags: 'key access lock' },
  { id: 'solar:lock-bold-duotone', tags: 'lock secure private' },
  { id: 'solar:flag-bold-duotone', tags: 'flag marker section' },
  { id: 'solar:bookmark-bold-duotone', tags: 'bookmark save mark' },
  // Wall & Surface
  { id: 'solar:wallpaper-bold-duotone', tags: 'wall wallpaper memorial plaque' },
  { id: 'solar:gallery-bold-duotone', tags: 'gallery image wall plaque' },
  { id: 'solar:palette-bold-duotone', tags: 'palette color design art' },
  { id: 'solar:frame-bold-duotone', tags: 'frame picture plaque' },
  // Religious & Spiritual
  { id: 'solar:bolt-bold-duotone', tags: 'bolt lightning spirit' },
  { id: 'solar:fire-bold-duotone', tags: 'fire flame eternal candle' },
  { id: 'solar:lamp-bold-duotone', tags: 'lamp light eternal candle' },
  // Grid & Layout
  { id: 'solar:widget-bold-duotone', tags: 'widget grid layout section' },
  { id: 'solar:widget-2-bold-duotone', tags: 'widget grid layout' },
  { id: 'solar:tuning-2-bold-duotone', tags: 'tuning settings adjust' },
  { id: 'solar:layers-bold-duotone', tags: 'layers stack level tier' },
  // Misc
  { id: 'solar:hand-money-bold-duotone', tags: 'money payment sale' },
  { id: 'solar:tag-price-bold-duotone', tags: 'price tag sale' },
  { id: 'solar:sale-bold-duotone', tags: 'sale discount deal' },
  { id: 'solar:check-circle-bold-duotone', tags: 'check done available' },
  { id: 'solar:close-circle-bold-duotone', tags: 'close remove sold' },
  { id: 'solar:clock-circle-bold-duotone', tags: 'clock time reserved wait' },
  { id: 'solar:calendar-bold-duotone', tags: 'calendar date schedule' },
  { id: 'solar:chart-2-bold-duotone', tags: 'chart report graph' },
  { id: 'solar:pie-chart-2-bold-duotone', tags: 'pie chart stats' },
  { id: 'solar:settings-bold-duotone', tags: 'settings gear config maintenance' },
  { id: 'solar:danger-triangle-bold-duotone', tags: 'warning danger alert' },
  { id: 'solar:info-circle-bold-duotone', tags: 'info help about' },
  { id: 'solar:forbidden-circle-bold-duotone', tags: 'forbidden blocked banned' },
  { id: 'solar:eye-bold-duotone', tags: 'eye view visible' },
  { id: 'solar:pen-bold-duotone', tags: 'pen edit write' },
  { id: 'solar:ruler-pen-bold-duotone', tags: 'ruler design layout' },
  { id: 'solar:magnifer-bold-duotone', tags: 'search find magnify' },
  { id: 'solar:filter-bold-duotone', tags: 'filter funnel sort' },
  { id: 'solar:sort-bold-duotone', tags: 'sort order arrange' },
  { id: 'solar:routing-bold-duotone', tags: 'route path workflow' },
  { id: 'solar:transfer-horizontal-bold-duotone', tags: 'transfer move swap' },
  { id: 'solar:login-bold-duotone', tags: 'login enter access' },
  { id: 'solar:logout-2-bold-duotone', tags: 'logout exit leave' },
  { id: 'solar:add-circle-bold-duotone', tags: 'add plus new create' },
  { id: 'solar:minus-circle-bold-duotone', tags: 'minus remove subtract' },
  { id: 'solar:maximize-bold-duotone', tags: 'maximize expand fullscreen' },
  { id: 'solar:minimize-bold-duotone', tags: 'minimize collapse shrink' },
  { id: 'solar:copy-bold-duotone', tags: 'copy duplicate clone' },
  { id: 'solar:trash-bin-trash-bold-duotone', tags: 'trash delete remove bin' },
  { id: 'solar:diskette-bold-duotone', tags: 'save disk floppy' },
  { id: 'solar:download-bold-duotone', tags: 'download export save' },
  { id: 'solar:upload-bold-duotone', tags: 'upload import' },
  { id: 'solar:share-bold-duotone', tags: 'share send' },
  { id: 'solar:link-bold-duotone', tags: 'link chain connect' },
  { id: 'solar:notification-bold-duotone', tags: 'notification bell alert' },
  { id: 'solar:chat-round-bold-duotone', tags: 'chat message comment' },
  { id: 'solar:phone-bold-duotone', tags: 'phone call contact' },
  { id: 'solar:letter-bold-duotone', tags: 'letter email mail' },
  { id: 'solar:camera-bold-duotone', tags: 'camera photo picture' },
  { id: 'solar:document-bold-duotone', tags: 'document file paper' },
  { id: 'solar:folder-bold-duotone', tags: 'folder directory organize' },
  { id: 'solar:database-bold-duotone', tags: 'database storage data' },
  { id: 'solar:server-bold-duotone', tags: 'server system infrastructure' },
  { id: 'solar:shield-check-bold-duotone', tags: 'shield check verified approved' },
  { id: 'solar:verified-check-bold-duotone', tags: 'verified check approved' },
];

interface IconPickerProps {
  value: string;
  onChange: (iconId: string) => void;
  color?: string;
}

const IconPicker: React.FC<IconPickerProps> = ({ value, onChange, color = 'var(--primary-400)' }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    if (!search) return ICON_SET;
    const q = search.toLowerCase();
    return ICON_SET.filter(i => i.id.toLowerCase().includes(q) || i.tags.includes(q));
  }, [search]);

  return (
    <>
      {/* Trigger button */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <label style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Icon</label>
        <button onClick={() => setOpen(true)} style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          padding: '8px 12px', borderRadius: 'var(--radius-md)',
          background: 'var(--input-bg)', border: '1px solid var(--input-border)',
          cursor: 'pointer', fontFamily: 'var(--font-body)', color: 'var(--input-text)',
          fontSize: '13px', transition: 'border-color 0.15s',
        }}>
          {value ? (
            <Icon icon={value} width={20} style={{ color, flexShrink: 0 }} />
          ) : (
            <div style={{ width: 20, height: 20, borderRadius: 4, background: 'rgba(148,163,184,0.10)' }} />
          )}
          <span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {value ? value.replace('solar:', '').replace('-bold-duotone', '') : 'Choose icon...'}
          </span>
          <Icon icon="solar:alt-arrow-down-bold-duotone" width={14} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
        </button>
      </div>

      {/* Picker overlay */}
      {open && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {/* Backdrop */}
          <div onClick={() => setOpen(false)} style={{
            position: 'absolute', inset: 0,
            background: 'rgba(0,0,0,0.50)', backdropFilter: 'blur(4px)',
          }} />

          {/* Panel */}
          <div style={{
            position: 'relative', width: '480px', maxHeight: '520px',
            background: 'var(--modal-bg)', backdropFilter: 'blur(24px)',
            border: '1px solid var(--border-base)', borderRadius: '12px',
            display: 'flex', flexDirection: 'column', overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
          }}>
            {/* Header */}
            <div style={{ padding: '16px 18px 12px', borderBottom: '1px solid var(--border-base)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: 'var(--text-primary)', fontWeight: 700, fontSize: '15px', fontFamily: 'var(--font-heading)' }}>Choose Icon</span>
                <button onClick={() => setOpen(false)} style={{
                  background: 'var(--bg-elevated)', border: 'none', borderRadius: '6px',
                  width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', color: 'var(--text-muted)',
                }}>
                  <Icon icon="solar:close-circle-bold-duotone" width={16} />
                </button>
              </div>
              <div style={{ position: 'relative' }}>
                <Icon icon="solar:magnifer-bold-duotone" width={16} style={{
                  position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
                  color: 'var(--text-muted)',
                }} />
                <input
                  autoFocus
                  placeholder="Search icons... (e.g. tree, building, star)"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  style={{
                    width: '100%', background: 'var(--input-bg)',
                    border: '1px solid var(--input-border)', borderRadius: '8px',
                    padding: '9px 12px 9px 32px', color: 'var(--input-text)', fontSize: '13px',
                    fontFamily: 'var(--font-body)', outline: 'none',
                  }}
                />
              </div>
              <div style={{ color: 'var(--text-faint)', fontSize: '11px', marginTop: '6px' }}>
                {filtered.length} icons · Solar Bold Duotone
              </div>
            </div>

            {/* Grid */}
            <div style={{
              flex: 1, overflowY: 'auto', padding: '14px 18px',
              display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '6px',
              alignContent: 'start',
            }}>
              {filtered.map(ic => {
                const isSelected = value === ic.id;
                return (
                  <button key={ic.id} title={ic.id.replace('solar:', '').replace('-bold-duotone', '')}
                    onClick={() => { onChange(ic.id); setOpen(false); }}
                    style={{
                      width: '100%', aspectRatio: '1', borderRadius: '8px', border: 'none',
                      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: isSelected ? 'var(--nav-item-active-bg)' : 'var(--bg-elevated)',
                      outline: isSelected ? '2px solid var(--primary-600)' : '1px solid transparent',
                      transition: 'all 0.12s ease',
                    }}
                    onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = 'var(--nav-item-hover)'; }}
                    onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'var(--bg-elevated)'; }}
                  >
                    <Icon icon={ic.id} width={22} style={{ color: isSelected ? color : 'var(--text-secondary)' }} />
                  </button>
                );
              })}
              {filtered.length === 0 && (
                <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '24px 0', color: 'var(--text-muted)', fontSize: '13px' }}>
                  No icons found for "{search}"
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IconPicker;
